import React from 'react'
import { useNavigate } from 'react-router-dom';
import ButtonComponent from '../../components/ButtonComponent';

const CookieTrackingPolicy = () => {
    const navigate = useNavigate();
    const handleBackToPolicyPage = () => {
        navigate('/documents');
    }
    return (
        <>
            <div className="container mt-5 privacy-policy"><ButtonComponent title='Back to Policy Page' backgroundColor=' #590B21' onClick={handleBackToPolicyPage} /></div>
            <div className="container mt-2 mb-5 py-4">
                <h3 className='fw-bold'>Cookie and Tracking Policy</h3>
                <h6 className='fw-bold'>CURRY KING (PRIVATE) LIMITED</h6>
                <p> Version 1.2 | Last Updated: 6th May 2025</p>
                <p>
                    This Cookie and Tracking Policy outlines how Curry King (Private) Limited ("we", "us", or "our") uses cookies and similar tracking technologies when you use our website, mobile applications (iOS and Android), and digital services. It explains what these technologies are, why we use them, and your rights to control our use of them.
                </p>
                <hr />
                <h5 className='fw-bold'>1. What Are Cookies?</h5>
                <p>
                    Cookies are small text files placed on your device by websites and applications you visit. They enable features such as remembering user preferences, storing order data temporarily, and improving user experience. Cookies do not typically contain personally identifiable information.
                </p>
                <hr />
                <h5 className='fw-bold'>2. Types of Cookies We Use</h5>
                <h6 className='fw-bold'>Essential Cookies</h6>
                <p>
                    These cookies are necessary for the proper functioning of our services. They enable core functionalities such as order processing, secure login, and cart management. Disabling these may affect service availability.
                </p>
                <h6 className='fw-bold'>Performance and Analytics Cookies</h6>
                <p>
                    We use cookies provided by third parties (such as Google Analytics and Firebase) to measure how users interact with our site and apps. These cookies help us understand usage trends and improve performance.
                </p>
                <h6 className='fw-bold'>Functionality Cookies</h6>
                <p>
                    These cookies help us remember your preferences—such as your chosen language, delivery area, or meal type—to provide a customised experience.
                </p>
                <h6 className='fw-bold'>Marketing and Tracking Cookies</h6>
                <p>
                    These cookies may be set by advertising platforms such as Facebook and Google. They help us serve personalised advertisements and measure campaign effectiveness. Data collected is anonymised or pseudonymised wherever possible.
                </p>
                <hr />
                <h5 className='fw-bold'>3. Tracking in Mobile Applications</h5>
                <p>Our mobile apps may use technologies similar to cookies, such as device identifiers and software development kits (SDKs), to collect usage data, monitor performance, and send notifications. Tracking in apps may include anonymised crash logs, session analytics, and campaign attribution.</p>
                <p>
                    iOS users will be prompted through Apple’s App Tracking Transparency (ATT) framework to grant or deny permission. Android users may manage tracking permissions via device settings.
                </p>
                <hr />
                <h5 className='fw-bold'>4. Your Consent</h5>
                <p>By continuing to use our website or applications, you consent to the use of cookies and tracking technologies in accordance with this policy. Where required by law, we will request your explicit consent before placing or accessing non-essential cookies on your device.</p>
                <hr />
                <h5 className='fw-bold'>5. Managing or Disabling Cookies</h5>
                <p>You can manage or disable cookies at any time through your browser settings. On most browsers, you may:</p>
                <ul>
                    <li>
                        Block all cookies
                    </li>
                    <li>
                        Clear existing cookies
                    </li>
                    <li>
                        Set preferences for specific websites
                    </li>
                </ul>
                <p>
                    Disabling essential cookies may affect the functionality and performance of our services.
                </p>
                <p>In mobile applications, you may disable tracking through your device's privacy or application settings. Some features may be affected if tracking is disabled.</p>
                <hr />
                <h5 className='fw-bold'>6. Use of Third-Party Services</h5>
                <p>We may use third-party analytics and advertising services, including but not limited to:</p>
                <ul>
                    <li>
                        Google Analytics
                    </li>
                    <li>
                        Facebook Pixel
                    </li>
                    <li>
                        Firebase Analytics
                    </li>
                    <li>
                        Meta SDK
                    </li>
                </ul>
                <p>These third parties may use their own cookies and tracking mechanisms. We do not control these technologies, and their use is governed by their respective privacy policies.</p>
                <hr />
                <h5 className='fw-bold'>7. Data Retention and Security</h5>
                <p>Data collected through cookies and tracking technologies is retained only as long as necessary for operational, legal, or compliance purposes. All reasonable efforts are taken to anonymise or aggregate data, and to protect it from unauthorised access or misuse.</p>
                <hr />
                <h5 className='fw-bold'>8. Changes to This Policy</h5>
                <p>We may update this Cookie and Tracking Policy from time to time to reflect changes in our practices, legal requirements, or technology. Any updates will be published on our website and within our applications with the revised effective date.</p>
                <hr />
                <h5 className='fw-bold'>9. Contact Us</h5>
                <p>If you have any questions about this policy or how we use cookies and tracking technologies, please contact us:</p>
                <strong>Curry King (Private) Limited</strong>
                <br />
                55/72, Vauxhall Lane, Colombo 2, Sri Lanka
                <br />
                Email: <strong>support@curryking.lk</strong>
                <p>Phone: <strong>+94 11 444 1300</strong></p>
                <hr />
            </div>
        </>
    )
}

export default CookieTrackingPolicy;